import { VideoPreference, VideoPreferences, } from 'amazon-chime-sdk-js';
import { streemLogger } from '../util/streem_logger';
import { invariant } from '@streem/toolbox';
import { AWS_ATTENDEE_PREFIX } from '../util/constants';
export class VideoPriorityBasedPolicyManager {
    constructor(audioVideoFacade, videoPriorityBasedPolicy) {
        this.audioVideoFacade = audioVideoFacade;
        this.videoPriorityBasedPolicy = videoPriorityBasedPolicy;
        this.logger = streemLogger.extend('sdk-chime-video:VideoPriorityBasedPolicyManager');
    }
    addVideoPreference(remoteAttendee) {
        // if this is null, server side network adaptation is not enabled, so there is no need to set video preferences
        if (!this.videoPriorityBasedPolicy) {
            return;
        }
        // This supports server side network adaptation features:
        //     https://aws.github.io/amazon-chime-sdk-js/modules/prioritybased_downlink_policy.html#enabling-server-side-network-adaption-features-
        const videoSourcesToDisplay = this.audioVideoFacade
            .getRemoteVideoSources()
            .filter(videoSource => {
            // filter out AWS attendees just in case (probably not necessary because they should not have video)
            return !videoSource.attendee.externalUserId.startsWith(AWS_ATTENDEE_PREFIX);
        });
        // if the current attendee is not in the list, add it
        if (!videoSourcesToDisplay.some(videoSource => videoSource.attendee.attendeeId === remoteAttendee.attendeeId)) {
            videoSourcesToDisplay.push({
                attendee: {
                    attendeeId: remoteAttendee.attendeeId,
                    externalUserId: remoteAttendee.externalUserId,
                },
            });
        }
        this.logger.debug(`Adding video preference for user Id: ${remoteAttendee.externalUserId}, updating video preferences: ${videoSourcesToDisplay.length}`);
        this.updateVideoPreferenceFromFilteredVideoSources(videoSourcesToDisplay);
    }
    removeVideoPreference(remoteAttendee) {
        // if this is null, server side network adaptation is not enabled, so there is no need to set video preferences
        if (!this.videoPriorityBasedPolicy) {
            return;
        }
        const videoSourcesToDisplay = this.audioVideoFacade
            .getRemoteVideoSources()
            .filter(videoSource => {
            // filter out AWS attendees () and the remote attendee whose track is being disconnected
            return (!videoSource.attendee.externalUserId.startsWith(AWS_ATTENDEE_PREFIX) &&
                videoSource.attendee.attendeeId !== remoteAttendee.attendeeId);
        });
        this.logger.debug(`Removing video preference for user Id: ${remoteAttendee.externalUserId}, updating video preferences: ${videoSourcesToDisplay.length}`);
        this.updateVideoPreferenceFromFilteredVideoSources(videoSourcesToDisplay);
    }
    updateVideoPreferenceFromFilteredVideoSources(videoSources) {
        invariant(this.videoPriorityBasedPolicy, 'VideoPriorityBasedPolicy is not defined');
        const videoPreferences = VideoPreferences.prepare();
        videoSources.forEach(videoSource => {
            this.logger.debug(`Adding video preference for attendeeId: ${videoSource.attendee.attendeeId}`);
            // This sets priority to 1 for all remote attendees, since we currently only have 1
            //    and are not likely to have more than a few in the future.
            videoPreferences.add(new VideoPreference(videoSource.attendee.attendeeId, 1));
        });
        this.videoPriorityBasedPolicy.chooseRemoteVideoSources(videoPreferences.build());
    }
}
//# sourceMappingURL=video_priority_based_policy_manager.js.map